const SITE_URL = 'https://hoosierlifeinsurance.com';
const SCHEMA_ID = 'schema-author-benjamin-wright';

export const benjaminWrightSchema = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  '@id': `${SITE_URL}/about#agent`,
  name: 'Benjamin Wright',
  jobTitle: 'Licensed Life Insurance Agent',
  description: 'Indiana-licensed independent life insurance agent serving Indianapolis, Fishers, Noblesville, Carmel, and all of Central Indiana. Helps families compare 20+ A-rated carriers for term life, whole life, IUL, final expense insurance, and annuities.',
  url: `${SITE_URL}/about`,
  telephone: '+13176482983',
  email: 'info@hoosierlifeinsurance.com',
  worksFor: {
    '@type': 'InsuranceAgency',
    '@id': `${SITE_URL}/#business`,
    name: 'Hoosier Life Insurance',
    url: SITE_URL,
    address: {
      '@type': 'PostalAddress',
      streetAddress: '5625 German Church Road',
      addressLocality: 'Indianapolis',
      addressRegion: 'IN',
      postalCode: '46235',
      addressCountry: 'US',
    },
  },
  hasCredential: [
    {
      '@type': 'EducationalOccupationalCredential',
      credentialCategory: 'license',
      name: 'Indiana Life Insurance License',
      recognizedBy: { '@type': 'Organization', name: 'Indiana Department of Insurance' },
    },
  ],
  knowsAbout: [
    'Term Life Insurance',
    'Whole Life Insurance',
    'Final Expense Insurance',
    'Indexed Universal Life Insurance (IUL)',
    'Annuities',
    'Mortgage Protection Insurance',
    'No Medical Exam Life Insurance',
    'Life Insurance Indianapolis Indiana',
    'Life Insurance Fishers Indiana',
    'Life Insurance Noblesville Indiana',
    'Generational Wealth Building',
    'Life Insurance for Seniors',
  ],
  areaServed: [
    { '@type': 'State', name: 'Indiana' },
    { '@type': 'City', name: 'Indianapolis' },
    { '@type': 'City', name: 'Fishers' },
    { '@type': 'City', name: 'Noblesville' },
    { '@type': 'City', name: 'Carmel' },
    { '@type': 'City', name: 'Westfield' },
    { '@type': 'City', name: 'Greenwood' },
  ],
  sameAs: [
    'https://www.linkedin.com/in/benjaminwrightinsurance',
    'https://www.facebook.com/hoosierlifeinsurance',
  ],
};

export function injectAuthorSchema(): void {
  if (document.getElementById(SCHEMA_ID)) return;
  const el = document.createElement('script');
  el.id = SCHEMA_ID;
  el.type = 'application/ld+json';
  el.textContent = JSON.stringify(benjaminWrightSchema);
  document.head.appendChild(el);
}

export function removeAuthorSchema(): void {
  document.getElementById(SCHEMA_ID)?.remove();
}
